import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
// material
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// react icons
// material icons
// other icons
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
// ----------------------------------------------------------------------

export default function AppointmentToolbar({
  numSelected,
  filterName,
  onFilterName,
  parent,
  setAddAppointment,
  setAddEditAppointmentTitle,
  setFromdate,
  setTableRowsNamse,
  fromDate,
  allLeadList,
  selectLead,
  setSelectLead,
  setAddEditAppointment
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);
  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  useEffect(() => {}, [fromDate]);
  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Select
                id="Lead"
                fullWidth
                disabled
                onChange={(e) => setSelectLead(e.target.value)}
                value={selectLead}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectLead}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Lead
                </MenuItem>
                {allLeadList.length > 0 &&
                  allLeadList.map((leadItem, leadIndex) => {
                    const itemValue = {
                      leadId: leadItem.leadId,
                      customerName: leadItem.customerName
                    };
                    return <MenuItem value={itemValue.leadId}>{itemValue.customerName}</MenuItem>;
                  })}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id=""
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Select Date"
                type="date"
                defaultValue={fromDate}
                onChange={(e) => {
                  setFromdate(e.target.value);
                  setTableRowsNamse([]);
                }}
              />
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Button
            className="mainBtn otherBtn"
            onClick={(e) => {
              setAddAppointment(true);
              setAddEditAppointmentTitle('Add Appointment');
              setAddEditAppointment({
                lead: ' ',
                purpose: '',
                appointmentType: ' ',
                name: '',
                mobile: '',
                appointmentDate: '',
                addressType: ' ',
                address: '',
                landmark: '',
                state: null,
                city: null,
                pin: '',
                comments: ''
              });
            }}
          >
            New Appointment
          </Button>
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            disabled
            placeholder="Search Appointment"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
